import AlchemyModal, { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import { BoxProps } from 'UIKit/Box/types'
import React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import { ModalColorTheme } from 'theme/modal/colors'

const ForgotPasswordModal: React.FC<{ onDismiss: () => void; label: string } & BoxProps> = ({
  onDismiss,
  label,
  children,
  ...props
}) => {
  return (
    <StyledModal onDismiss={onDismiss} colorTheme={ModalColorTheme.Darkblue} {...props}>
      <ModalHeader colorTheme={ModalColorTheme.Darkblue} title={label} />
      <ModalBody borderRadius={theme.radii.modal} height="100%">
        {children}
      </ModalBody>
    </StyledModal>
  )
}

const StyledModal = styled(AlchemyModal)`
  ${({ theme }) => theme.mediaQueries.sm} {
    min-width: 440px !important;
    max-width: 440px !important;
  }
`

export default ForgotPasswordModal
